<template>
  <i-container fluid class="_padding-0">
    <div class="_float-left">
      <a href="https://fmph.uniba.sk/en/" target="_blank" rel="noopener">
        <img height="100" width="100" src="./../assets/cu-logo.png"
        class="lazyload _display-xs-none _display-sm-none _display-md-none _display-lg-block pic-left"
        alt="Logo of the Comenius University Bratislava">
      </a>
    </div>

    <div class="_float-right">
      <a href="https://fmph.uniba.sk/en/microsites/daa/division-of-astronomy-and-astrophysics/" target="_blank" rel="noopener"><img
          height="100" width="100" src="./../assets/fmph-logo.png"
          class="lazyload _display-xs-none _display-sm-none _display-md-none _display-lg-block pic-right"
          alt="Logo of the Faculty of Mathematics, Physics and Informatics of the Comenius University Bratislava"></a>
    </div>

    <i-header size="sm"
              class="_text-center _background-white _padding-top-0 _padding-bottom-xs-1 _padding-bottom-sm-1 _padding-bottom-md-3 _padding-bottom-lg-3 _padding-bottom-xl-3">
      <div class="_clearfix">
        <h1>Space Debris Light Curve Database</h1>
        <h6 class="_font-size-sm">of the Faculty of Mathematics, Physics and Informatics, Comenius University in Bratislava</h6>
        <p class="data_release_number">Data Release 3</p>
      </div>
    </i-header>
  </i-container>
</template>

<script>
  export default {
    name: "lcd-header"
  }
</script>

<style scoped>
  img {
    filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale");
    -webkit-filter: grayscale(100%);
    position: absolute;
    top: 1rem;
    -webkit-transition: all .25s ease-in-out;
    transition: all .25s ease-in-out;
  }

  img:hover {
    filter: none;
    -webkit-filter: grayscale(0%);
  }

  h6 {
    margin-top: -.75rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .pic-left {
    left: 1rem;
  }

  .pic-right {
    right: 1rem;
  }

  .data_release_number {
    color: dimgray;
    font-size: 23px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue